import { RedRed60, Box } from '@sequencehq/core-components'
import { FC } from 'react'
import { PricingGroup, usePricingTable } from '../usePricingTable'
import { PricingTableCompactMinimumRow } from './PricingTableCompactRows'
import { PricingTableCompactGroup } from './PricingTableCompactGroup'
import { PricingTableCompactHeader } from './PricingTableCompactHeader'
import { useProductReordering } from 'Cube/domain'

const groupSortValue = (group: PricingGroup) => {
  if (group.minimumRow) {
    return 1
  }

  if (group.pricingRows[0].isGlobalDiscountRow) {
    return 0
  }

  return 2
}

/**
 * Standard price group goes first, then minimum group, and then
 * the global discount at the bottom.
 */
const sortGroups = (a: PricingGroup, b: PricingGroup) => {
  const aSortValue = groupSortValue(a)
  const bSortValue = groupSortValue(b)

  if (aSortValue < bSortValue) {
    return 1
  }
  if (aSortValue > bSortValue) {
    return -1
  }
  return 0
}

export const PricingTableCompact: FC<{
  phaseId: string
}> = props => {
  const { enabled: productReorderEnabled } = useProductReordering()
  const { validationErrors, pricingGroups } = usePricingTable({
    phaseId: props.phaseId
  })

  return (
    <Box
      data-testid="phase.pricingTable"
      padding={!productReorderEnabled ? '0 16px' : undefined}
      paddingTop="8px"
    >
      <Box
        marginBottom="8px"
        border={validationErrors.length ? `1px solid ${RedRed60}` : ''}
        borderRadius="8px"
      >
        <PricingTableCompactHeader />
        {pricingGroups.length > 0 &&
          pricingGroups.sort(sortGroups).map(group => {
            const key = `group${
              group.minimumRow?.id || group.pricingRows[0]?.id
            }}`

            return (
              <Box key={key}>
                {group.minimumRow && (
                  <PricingTableCompactMinimumRow
                    minimumRow={group.minimumRow}
                  />
                )}
                <PricingTableCompactGroup
                  phaseId={props.phaseId}
                  group={group}
                />
              </Box>
            )
          })}
      </Box>
    </Box>
  )
}
